export default "__VITE_ASSET__Cn6CUVw3__"